var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutomatedTrafficFineNotificationServicesMoney(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7 7.625H7.5M16.5 16.375H18.3M6.6 19H17.4C19.3882 19 21 17.433 21 15.5V8.5C21 6.567 19.3882 5 17.4 5H6.6C4.61177 5 3 6.567 3 8.5V15.5C3 17.433 4.61177 19 6.6 19ZM13.8 12C13.8 12.9665 12.9941 13.75 12 13.75C11.0059 13.75 10.2 12.9665 10.2 12C10.2 11.0335 11.0059 10.25 12 10.25C12.9941 10.25 13.8 11.0335 13.8 12Z",
    stroke: "#00453C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomatedTrafficFineNotificationServicesMoney);
export default __webpack_public_path__ + "static/media/AutomatedTrafficFineNotificationServicesMoney.8db88db5cbde496a60113fd2d1a4a1ac.svg";
export { ForwardRef as ReactComponent };